// ABHA address policy (NHA CRT_ABHA_112). Mirrors the backend rules (BE-M1a).
export const ABHA_ADDRESS_RULES_TEXT =
  'ABHA address must be 8 to 18 characters: letters and numbers, with at most one dot (.) ' +
  'and one underscore (_), not at the start or end.';

export const ABHA_ADDRESS_EXISTS_MESSAGE = 'ABHA Address is already exist';

// Local part only (no @suffix). Returns an error message, or null when valid.
export function validateAbhaAddressLocal(value) {
  const s = String(value ?? '').trim().toLowerCase();
  if (s.length < 8 || s.length > 18) return ABHA_ADDRESS_RULES_TEXT;
  if (!/^[a-z0-9]([a-z0-9._]*[a-z0-9])?$/.test(s)) return ABHA_ADDRESS_RULES_TEXT;
  if ((s.match(/\./g) || []).length > 1 || (s.match(/_/g) || []).length > 1) {
    return ABHA_ADDRESS_RULES_TEXT;
  }
  return null;
}
